import {EdocOptions, PesFormatNamingContextRegistry, StepBase, StepType, TransactionStep} from '@pes/ui';
import {StepLbpaType} from '../enum/step-lbpa-type.enum';
import {
    StepSignatureParcoursLbpaComponent
} from '../component/step-parcours-lbpa/step-signature-parcours-lbpa.component';

export class ParcoursLbpaStep extends StepBase implements TransactionStep {
    /**
     * @inheritDoc
     */
    public transactions: string[] = null;
    edocOptions: EdocOptions[];

    constructor(config?: any, type: StepType = StepType.SIGNATURE) {
        super(StepLbpaType.SIGNATURE_PARCOURS_LBPA, StepSignatureParcoursLbpaComponent.VIEW_REF, null, null);
        this.init(config);
        this.title = this.title || 'steps.signature';
    }
}

PesFormatNamingContextRegistry.getInstance().add(StepSignatureParcoursLbpaComponent.VIEW_REF, StepSignatureParcoursLbpaComponent);



// WEBPACK FOOTER //
// ./src/app/step/parcours-lbpa.step.ts